import { apiClient } from './apiClient';
import { documentationReportsBase } from './documentationApi';

export type DocumentationExpiredPage = {
  pageId: string;
  spaceId: string;
  pageTitle: string;
  spaceName: string;
  publishedAtUtc?: string | null;
  expiresAtUtc?: string | null;
  updatedAtUtc: string;
};

export type DocumentationExpiredPageListResult = {
  items: DocumentationExpiredPage[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export type DocumentationPageViewStats = {
  pageId: string;
  spaceId: string;
  pageTitle: string;
  spaceName: string;
  viewCount: number;
};

export type DocumentationPageViewListResult = {
  items: DocumentationPageViewStats[];
  totalCount: number;
  totalViewCount: number;
  page: number;
  pageSize: number;
};

export async function listExpiredDocumentationPages(params?: {
  page?: number;
  pageSize?: number;
}): Promise<DocumentationExpiredPageListResult> {
  const response = await apiClient.get<DocumentationExpiredPageListResult>(
    `${documentationReportsBase()}/expired`,
    { params },
  );
  return response.data;
}

export async function listDocumentationLiveViews(params?: {
  fromUtc?: string;
  toUtc?: string;
  page?: number;
  pageSize?: number;
}): Promise<DocumentationPageViewListResult> {
  const response = await apiClient.get<DocumentationPageViewListResult>(
    `${documentationReportsBase()}/views`,
    { params },
  );
  return response.data;
}
